import clsx from 'clsx';
import type { LottieComponentProps } from 'lottie-react';
import { lazy, Suspense, useMemo } from 'react';

import * as styles from './styles.css';

const Lottie = lazy(() => import('lottie-react'));
type AnimationProps = Omit<LottieComponentProps, 'animationData'>;
export type LazyLottieProps = AnimationProps & {
  load: () => Promise<{ default: unknown }>;
};

export function LazyLottie({ load, ...props }: LazyLottieProps) {
  const Animation = useMemo(
    () =>
      lazy(async () => {
        const { default: animationData } = await load();
        return {
          default: function LoadedAnimation(animationProps: AnimationProps) {
            return <Lottie {...animationProps} animationData={animationData} />;
          },
        };
      }),
    [load]
  );
  return (
    <Suspense
      fallback={
        <span
          aria-hidden="true"
          className={clsx(styles.root, props.className)}
        />
      }
    >
      <Animation {...props} />
    </Suspense>
  );
}
